import { Picker, List } from "antd-mobile";
import { appMethod as app } from '@utils/app';

import { getCurrentPageQueryParams, convertLineStyleData } from '@utils/tools';
import OfficialPage from '../OfficialPage';

import './AddAddress.less';

import { TopNav } from '@common/top-nav/TopNav';

export default class AddAddress extends OfficialPage {
  state = {
    areaCodeArr: [
      {
        //区号
        label: '中国大陆 +86',
        value: 0
      },
      {
        label: '中国澳门 +853',
        value: 1
      },
      {
        label: '中国香港 +852',
        value: 2
      },
      {
        label: '中国台湾 +886',
        value: 3
      }
    ],
    areaCodeIndex: 0,
    nationListMap: [], // 国家列表字典
    nationSelectedIndex: [0], // 当前展示的国家索引下标
    nationList: [], // 国家名称列表
    nationId: 1, // 国家海外地图id (oversea_region_id)
    nationname: '', // 当前展示的国家名称
    regionInfoText: '', // 显示地区字符
    addressId: '',
    orderId: '',
    detail: '',
    isDefault: 0,
    selectAddressId: '',
    addressList: [],
    isFromBack: false,
    from: '',
    showNewAddressDialog: true,
    address_id: '',
    localAddress: '',
    address_info: {
      name: '',
      contact: '',
      country: {
        text: '',
        id: ''
      },
      province: {
        text: '',
        id: ''
      },
      city: {
        text: '',
        id: ''
      },
      district: {
        text: '',
        id: ''
      },
      detailAddress: '',
      sex: 1,
      label: 3
    },
    selectRegion: [0, 0, 0],
    selectRegionId: [0, 0, 0],
    detailAddress: '',
    storeStyle: {}
  }
  selectAddressBack = false

  constructor(props) {
    super(props);
    document.title = '新增收货地址';
    // WEBAPP: 处理后一个页面回来的回调
    if (app.getCurrentPage().data || app.getCurrentPage().callbackData) {
      this.currentPage = app.getCurrentPage();
    }
  }

  // WEBAPP: 处理后一个页面回来的回调
  handleCurrentPage() {
    if (!this.currentPage) {
      return;
    }
    const { data, callbackData } = this.currentPage;
    if (data) {
      this.setData(data);
    }
    if (callbackData) {
      this.setData(callbackData);
      this.currentPage.clearCallbackData();
      if (this.currentPage.location) {
        this.location = this.currentPage.location;
        delete this.currentPage.location;
      }
    }
  }

  componentWillMount(options = getCurrentPageQueryParams()) {
    var newData = {}
    var id = options.id || ''
    newData.addressId = id
    var orderId = options.oid || ''
    newData.orderId = orderId
    var countryId = options.countryId || false
    if (countryId !== false) {
      newData.nationId = countryId
    }
    if (id) {
      app.setPageTitle('编辑收货地址')
    }
    this.setData(newData)
    this.dataInitial()
  }

  componentDidMount() {
    if (this.selectAddressBack) {
      this.getAllPickUpConfig()
    }
    this.data.detailAddress = this.data.address_info.detailAddress
  }

  dataInitial = () => {
    this.getAppECStoreConfig()
    let id = this.data.addressId
    if (id) {
      this.getAddressDetail(id)
    } else {
      // WEBAPP: 处理后一个页面回来的回调
      this.handleCurrentPage();
    }
    this.getNationList()
  }
  getNationList = () => {
    var _this = this
    app.sendRequest({
      url: '/index.php?r=Region/getNationList',
      data: {
        page: 1,
        page_size: 10
      },
      success: res => {
        let nationListMap = res.data.reverse()
        let selectedIndex = 0
        let nationList = nationListMap.map((it, idx) => {
          if (it.oversea_region_id == _this.data.nationId) {
            selectedIndex = idx
          }
          return {
            label: it.nation_name,
            value: it.oversea_region_id
          }
        })
        let nationSelectedIndex = [selectedIndex]
        let defaultNation =  nationListMap[selectedIndex]
        _this.setData({
          nationListMap,
          nationList,
          nationSelectedIndex,
          nationId: defaultNation.oversea_region_id,
          nationname: defaultNation.nation_name
        })
      }
    })
  }
  getAllPickUpConfig = () => {
    let _this = this
    app.sendRequest({
      url: '/index.php?r=AppEcommerce/GetAllPickUpConfig',
      data: {
        latitude: _this.location.lat,
        longitude: _this.location.lng
      },
      success: function(res) {
        _this.setData({
          suportExpress: res.data.config_data.express,
          suportSameCity: res.data.config_data.intra_city,
          suportSelfDelivery: res.data.config_data.is_self_delivery
        })
      }
    })
  }
  getAddressDetail = id => {
    var that = this
    app.sendRequest({
      url: '/index.php?r=AppShop/GetAddressById',
      data: { address_id: id },
      success: function(res) {
        var data = res.data
        var addressInfo = data.address_info
        var regionAry = [
            (addressInfo.province && addressInfo.province.text) || '',
            (addressInfo.city && addressInfo.city.text) || '',
            (addressInfo.district && addressInfo.district.text) || ''
          ],
          joinStr = ''
        let areaCodeIndex = 0
        let contact = addressInfo.contact || data.telphone
        if (contact.indexOf('+853-') == 0) {
          contact = contact.substring(5)
          areaCodeIndex = '1'
        } else if (contact.indexOf('+852-') == 0) {
          contact = contact.substring(5)
          areaCodeIndex = '2'
        } else if (contact.indexOf('+886-') == 0) {
          contact = contact.substring(5)
          areaCodeIndex = '3'
        } else if (contact.indexOf('1-') == 0) {
          // 加拿大
          contact = contact.substring(2)
        } else if (contact.indexOf('60-') == 0) {
          // 马来西亚
          contact = contact.substring(3)
        }
        if (regionAry[1] === regionAry[2] || regionAry[2] === '') {
          regionAry.pop()
        }
        if (data.address_info.country && data.address_info.country.id != 1) {
          joinStr = ' '
        }
        that.data.detailAddress = addressInfo.detailAddress
        that.setData({
          areaCodeIndex: areaCodeIndex,
          'address_info.name': addressInfo.name,
          'address_info.contact': contact,
          'address_info.country': addressInfo.country || { text: '', id: '' },
          nationId: addressInfo.country ? addressInfo.country.id || 1 : 1,
          'address_info.province': addressInfo.province || { text: '', id: '' },
          'address_info.city': addressInfo.city || { text: '', id: '' },
          'address_info.district': addressInfo.district || { text: '', id: '' },
          'address_info.detailAddress':
            addressInfo.detailAddress || data.detail_address,
          'address_info.sex': addressInfo.sex || 2,
          'address_info.label': addressInfo.label || 3,
          'address_info.regionInfoText': regionAry.join(joinStr),
          latitude: data.latitude,
          longitude: data.longitude
        })
        that.location = {
          lat: data.latitude,
          lng: data.longitude
        }
        that.getAllPickUpConfig()
        // WEBAPP: 处理后一个页面回来的回调
        that.handleCurrentPage();
      }
    })
  }
  nameInput = e => {
    this.setData({
      name: e.target.value
    })
  }
  contactInput = e => {
    this.setData({
      contact: e.target.value
    })
  }
  detailInput = e => {
    this.setData({
      detail: e.target.value
    })
  }
  setAddress = addressId => {
    var orderId = this.data.orderId
    app.sendRequest({
      url: '/index.php?r=AppShop/setAddress',
      data: {
        order_id: orderId,
        address_id: addressId
      },
      success: function(res) {
        app.turnBack()
      }
    })
  }
  setDefaultAddress = e => {
    var checked = e.target.value
    if (checked) {
      this.setData({
        isDefault: 1
      })
    } else {
      this.setData({
        isDefault: 0
      })
    }
  }
  sureAddAddress = () => {
    let _this = this
    let addressInfo = _this.data.address_info
    let addressId = _this.data.addressId
    let nationIsChina = +_this.data.nationId === 1
    let areaCodeIndex = this.data.areaCodeIndex
    if (!addressInfo.name) {
      app.showModal({
        content: '联系人不能为空'
      })
      return
    }
    if (!addressInfo.contact) {
      app.showModal({
        content: '电话不能为空'
      })
      return
    }
    if (
      nationIsChina &&
      ((areaCodeIndex == 0 && !/^1[0-9]{10}$/.test(addressInfo.contact)) ||
        (areaCodeIndex != 1 && !/^\d+$/.test(addressInfo.contact)))
    ) {
      app.showModal({
        content: '请填写正确的手机号'
      })
      return
    }
    if (!(addressInfo.province && addressInfo.province.text)) {
      app.showModal({
        content: '请选择收货地址'
      })
      return
    }
    if (!addressInfo.detailAddress) {
      app.showModal({
        content: '详细地址不能为空'
      })
      return
    }
    if (
      (nationIsChina && ~['89', '233'].indexOf(addressInfo.country.id)) ||
      (!nationIsChina && addressInfo.country.id == '1')
    ) {
      app.showModal({
        content: '所在地区与国家不匹配'
      })
      return
    }
    if (nationIsChina && areaCodeIndex) {
      switch (areaCodeIndex) {
        case '1':
          addressInfo.contact = '+853-' + addressInfo.contact
          break
        case '2':
          addressInfo.contact = '+852-' + addressInfo.contact
          break
        case '3':
          addressInfo.contact = '+886-' + addressInfo.contact
          break
      }
    }
    if (this.data.nationId == 89) {
      addressInfo.contact = '1-' + addressInfo.contact
    } else if (this.data.nationId == 233) {
      addressInfo.contact = '60-' + addressInfo.contact
    }
    let addressInfoCopy = JSON.parse(JSON.stringify(addressInfo))
    if (addressInfoCopy.detailAddress) {
      addressInfoCopy.detailAddress =
        addressInfoCopy.address + addressInfoCopy.detailAddress
      let index = addressInfoCopy.detailAddress.indexOf('区')
      addressInfoCopy.detailAddress = addressInfoCopy.detailAddress.substring(
        index + 1,
        addressInfoCopy.detailAddress.length
      )
    }
    if (addressInfoCopy.address) {
      delete addressInfoCopy.address
    }
    if (
      this.data.address_info.detailAddress.indexOf(this.data.detailAddress) !==
      -1
    ) {
      addressInfo.latitude = this.data.latitude
      addressInfo.longitude = this.data.longitude
    } else {
      delete addressInfo.latitude
      delete addressInfo.longitude
    }
    app.sendRequest({
      url: '/index.php?r=AppShop/addAddress',
      method: 'post',
      data: {
        address_info: addressInfo,
        address_id: addressId,
        is_default: 0
      },
      success: function(res) {
        app.showToast({
          title: '保存成功'
        })
        app.turnBack()
      },
      successStatusAbnormal: function(res) {
        console.log(res)
        if (res.data == '获取经纬度失败') {
          app.showModal({
            content: '该地址定位不到，请检查地址是否正确'
          })
          return false
        }
      }
    })
  }
  deleteAddress = e => {
    var _this = this
    app.showModal({
      content: '确定要删除地址？',
      showCancel: true,
      confirmText: '确定',
      cancelText: '取消',
      confirm: function() {
        app.sendRequest({
          url: '/index.php?r=AppShop/delAddress',
          data: {
            address_id: _this.data.addressId
          },
          success: function(res) {
            app.turnBack()
          }
        })
      }
    })
  }
  addAdressName = e => {
    this.setData({
      'address_info.name': e.target.value
    })
  }
  addAdressContact = e => {
    this.setData({
      'address_info.contact': e.target.value
    })
  }
  addAdressDetailAddress = e => {
    this.setData({
      'address_info.detailAddress': e.target.value
    })
  }
  selectAddressLabel = e => {
    this.setData({
      'address_info.label': e.currentTarget.dataset.label
    })
  }
  selectAddressSex = e => {
    this.setData({
      'address_info.sex': e.currentTarget.dataset.sex
    })
  }
  addSelectAddress = () => {
    app.turnToPage(
      '/eCommerce/pages/searchAddress/searchAddress?from=addAddress&nationId=' +
      this.data.nationId +
      '&nationname=' +
      this.data.nationname
    )
  }
  getAppECStoreConfig = () => {
    app.getAppECStoreConfig(res => {
      this.setData({
        storeStyle: res.color_config
      })
    })
  }
  selectNation = e => {
    let _this = this;
    let selectedNationId = e[0];
    let newData = {
      nationId: selectedNationId
    };
    this.data.nationList.some((n, nId) => {
      let f = n.value == selectedNationId;
      if (f) {
        newData.nationSelectedIndex = [nId];
        newData.nationname = n.label;
      }
      return f;
    });
    _this.setData(newData);
  }

  selectAreaCode = e => {
    this.setData({
      areaCodeIndex: e[0]
    })
  }

  render() {
    const {
      address_info,
      storeStyle,
      nationSelectedIndex,
      nationList,
      areaCodeArr,
      areaCodeIndex,
      nationId,
      suportExpress,
      suportSameCity,
      suportSelfDelivery,
      addressId
    } = this.state
    return (
      <div className="official-page add-address">
        <TopNav title="新增地址" />
        <div id="newAddressDialog">
          <div className="newAddressBox">
            <div className="newAddressView">
              <label>收货人</label>
              <input
                maxLength="20"
                type="text"
                placeholder="请填写收货人姓名"
                onInput={this.addAdressName}
                value={address_info.name || ''}
                onChange={() => {}}
              />
            </div>
            <div className="newAddressView">
              <label>性别</label>
              <div className="adress-label-box">
                <div
                  style={convertLineStyleData(
                    address_info.sex == 0
                      ? 'color:' +
                      storeStyle.theme +
                      ';border-color:' +
                      storeStyle.theme +
                      ';background:' +
                      storeStyle.theme +
                      '33'
                      : ''
                  )}
                  className={
                    'adressLabel ' + (address_info.sex == 0 ? 'active' : '')
                  }
                  onClick={this.selectAddressSex}
                  data-sex="0"
                >
                  女士
                </div>
                <div
                  style={convertLineStyleData(
                    address_info.sex == 1
                      ? 'color:' +
                      storeStyle.theme +
                      ';border-color:' +
                      storeStyle.theme +
                      ';background:' +
                      storeStyle.theme +
                      '33'
                      : ''
                  )}
                  className={
                    'adressLabel ' + (address_info.sex == 1 ? 'active' : '')
                  }
                  onClick={this.selectAddressSex}
                  data-sex="1"
                >
                  先生
                </div>
              </div>
            </div>
            <div className="newAddressView">
              <label>国家</label>
              <div className="nationName content-flex-end">
                {!!nationList.length && (<Picker
                  data={nationList}
                  cols={1}
                  value={[nationList[nationSelectedIndex].value]}
                  onOk={v => this.selectNation(v)}
                >
                  <List.Item></List.Item>
                </Picker>)}
              </div>
              <span className="ico-moon icon-rightarrow"></span>
            </div>
            <div className="newAddressView">
              <label>区号</label>
              <div className="area-code-picker content-flex-end">
              {nationId == 1 ? (
                <React.Fragment>
                  <Picker
                    data={areaCodeArr}
                    cols={1}
                    value={[areaCodeIndex]}
                    onOk={v => this.selectAreaCode(v)}
                  >
                    <List.Item></List.Item>
                  </Picker>
                </React.Fragment>
              ) : nationId == 89 ? (
                <React.Fragment>
                  <div className="area-code-picker">Canada +1</div>
                </React.Fragment>
              ) : (
                nationId == 233 && (
                  <React.Fragment>
                    <div className="area-code-picker">Malaysia +60</div>
                  </React.Fragment>
                )
              )}
              </div>
            </div>
            <div className="newAddressView">
              <label>手机号码</label>
              <input
                type="text"
                placeholder="请填写收货人手机号"
                onInput={this.addAdressContact}
                value={address_info.contact || ''}
                onChange={() => {}}
              />
            </div>
            <div className="newAddressView" onClick={this.addSelectAddress}>
              <label>所在地区</label>
              <input
                type="text"
                placeholder="请选择省市区"
                value={address_info.regionInfoText || ''}
                onChange={() => {}}
              />
              <span className="ico-moon icon-rightarrow"></span>
            </div>
            <div className="newAddressView">
              <label>详细地址</label>
              <input
                type="text"
                placeholder="详细地址（例如门牌号等）"
                onInput={this.addAdressDetailAddress}
                value={address_info.detailAddress || ''}
                onChange={() => {}}
              />
            </div>
            <div className="newAddressView">
              <label>选择标签</label>
              <div className="adress-label-box">
                <div
                  style={convertLineStyleData(
                    address_info.label == 0
                      ? 'color:' +
                      storeStyle.theme +
                      ';border-color:' +
                      storeStyle.theme +
                      ';background:' +
                      storeStyle.theme +
                      '33'
                      : ''
                  )}
                  className={
                    'adressLabel ' + (address_info.label == 0 ? 'active' : '')
                  }
                  onClick={this.selectAddressLabel}
                  data-label="0"
                >
                  家
                </div>
                <div
                  style={convertLineStyleData(
                    address_info.label == 1
                      ? 'color:' +
                      storeStyle.theme +
                      ';border-color:' +
                      storeStyle.theme +
                      ';background:' +
                      storeStyle.theme +
                      '33'
                      : ''
                  )}
                  className={
                    'adressLabel ' + (address_info.label == 1 ? 'active' : '')
                  }
                  onClick={this.selectAddressLabel}
                  data-label="1"
                >
                  学校
                </div>
                <div
                  style={convertLineStyleData(
                    address_info.label == 2
                      ? 'color:' +
                      storeStyle.theme +
                      ';border-color:' +
                      storeStyle.theme +
                      ';background:' +
                      storeStyle.theme +
                      '33'
                      : ''
                  )}
                  className={
                    'adressLabel ' + (address_info.label == 2 ? 'active' : '')
                  }
                  onClick={this.selectAddressLabel}
                  data-label="2"
                >
                  公司
                </div>
              </div>
            </div>
            <div>
              <label>取货方式</label>
              <div className="address-pick-up">
                <div>
              <span
                style={convertLineStyleData(suportExpress ? 'color:' + storeStyle.theme : '')}
                className={
                  'ico-moon icon-goods-support-delivery ' +
                  (suportExpress ? 'suporrt' : '')
                }
              ></span>
                  <span>快递</span>
                </div>
                <div>
              <span
                style={convertLineStyleData(suportSameCity ? 'color:' + storeStyle.theme : '')}
                className={
                  'ico-moon icon-goods-support-delivery ' +
                  (suportSameCity ? 'suporrt' : '')
                }
              ></span>
                  <span>同城</span>
                </div>
                <div>
              <span
                style={convertLineStyleData(
                  suportSelfDelivery ? 'color:' + storeStyle.theme : ''
                )}
                className={
                  'ico-moon icon-goods-support-delivery ' +
                  (suportSelfDelivery ? 'suporrt' : '')
                }
              ></span>
                  <span>自提</span>
                </div>
              </div>
            </div>
          </div>
          <div className="newAddressBottom">
            <div
              className="sureAddAddress"
              style={convertLineStyleData('background:' + storeStyle.theme)}
              onClick={this.sureAddAddress}
            >
              保存并使用
            </div>
            {addressId && (
              <div className="cancelAddAddress" onClick={this.deleteAddress}>
                删除收货地址
              </div>
            )}
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/official-page/add-address/AddAddress.jsx